import React, {useState} from 'react';
import {DateRangePicker} from "react-dates";
import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';
import moment from 'moment';
import StyledRangePicker from "./TBDateRangePicker.react.styles";



const TBDateRangePicker = ({setDateFilter, isCustomDate, filter = null}) => {
  const [focus, setFocus] = useState(null);
  const [dateRange, setRange] = useState({
    startDate: isCustomDate ? moment(filter?.startDate) : null,
    endDate: isCustomDate ? moment(filter?.endDate) : null
  });

  const { startDate, endDate } = dateRange;

  const selectDate = ({startDate, endDate}) => {
    setRange({startDate, endDate});
    if (startDate !== null && endDate !== null && setDateFilter) {
      setDateFilter(
        {
          startDate: startDate.toISOString(),
          endDate: endDate.toISOString()
        })
    }
  };

  return (
    <StyledRangePicker className={'tb-date-range-picker'}>
      <DateRangePicker
        startDate={startDate}
        startDateId={'unique_start_id'}
        endDate={endDate}
        endDateId={'unique_end_id'}
        onDatesChange={({startDate, endDate}) => selectDate({startDate, endDate})}
        focusedInput={focus}
        onFocusChange={focus => setFocus(focus)}
        showClearDates={true}
        enableOutsideDays={true}
        isOutsideRange={() => false}
        small={true}
      />
    </StyledRangePicker>
  );
};

export default TBDateRangePicker;